import React from "react";
import "./IndustryDetail1.css"; // Add styles for the layout in this file
import Industry from "../../img/Industry-2.png";



const IndustryDetail1 = () => {
  return (
    
    <div className="">
         <div className="industry-detail-container">
      <header className="industry-header2">
        <h1>CHOOSE THE BEST DEVELOPERS FOR YOUR E-COMMERCE PROJECT</h1>
      </header>
      <hr className="our-indusrty2-hr"/>
      <div className="industry-content-i2">
        {/* Image Section */}
        <div className="industry-image">
          <img src={Industry} alt="Laptop display" />
        </div>

        <div className="vertical-line-indusrty2"></div>

        {/* Right Side - Scrollable Content */}
        <div className="right-side-industry-2">
          {/* First indusrty2 */}
          <div className="our-indusrty2-section">
            <div className="id-indusrty2">01/</div>
            <h3>SAAS</h3>
            <p className="indusrty2-p">
              Our Evaluation & Design process serves as a solid foundation for
              the successful development and deployment of custom software solutions.
            </p>
           
          </div>
          <hr className="right-line-indusrty2"/>

          {/* Second indusrty2 */}
          <div className="our-indusrty2-section">
            <div className="id-indusrty2">02/</div>
            <h3>CORPORATE SITE</h3>
            <p className="indusrty2-p">
            Our Evaluation & Design process serves as a solid foundation for the successful development and deployment of custom software solutions.
            </p>
            
          </div>
          <hr className="right-line-indusrty2"/>

          {/* Third indusrty2 */}
          <div className="our-indusrty2-section">
            <div className="id-indusrty2">03/</div>
            <h3>MARKET PLACES</h3>
            <p className="indusrty2-p">
            Our Evaluation & Design process serves as a solid foundation for the successful development and deployment of custom software solutions.
            </p>
           
          </div>
          

          {/* Fourth indusrty2 */}
         
          </div>
          
        </div>
    </div>
    </div>
  );
};

export default IndustryDetail1;
